import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { Content as Content2 } from '../../../../_externals/.pnpm/@radix-ui_react-popover@1.1.1_@types_react@18.3.5_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@radix-ui/react-popover/dist/index.js';
import { mediaQuery } from '../../../helpers/media.js';
import '../../../helpers/animation.js';
import { generateBorder, generatePadding } from '../../../helpers/tokens.js';
import '../../atoms/Icons/Minus/Minus.js';
import '../../atoms/Icons/Plus/Plus.js';
import '../../atoms/Icons/Right/Right.js';
import '../../atoms/Icons/Left/Left.js';
import '../../atoms/Icons/Down/Down.js';
import '../../atoms/Icons/Up/Up.js';
import '../../atoms/Icons/Tick/Tick.js';
import '../../atoms/Icons/Cross/Cross.js';
import '../../atoms/Icons/Hamburger/Hamburger.js';
import '../../atoms/Icons/Search/Search.js';
import '../../atoms/Icons/Cart/Cart.js';
import '../../atoms/Icons/Filter/Filter.js';
import '../../atoms/Icons/Profile/Profile.js';
import '../../atoms/Icons/ProfileCircleOutline/ProfileCircleOutline.js';
import '../../atoms/Icons/LoadingCircle/LoadingCircle.js';
import '../../atoms/Icons/CrossSolidCircleOutline/CrossSolidCircleOutline.js';
import '../../atoms/Icons/RadioButtonOutline/RadioButtonOutline.js';
import '../../atoms/Icons/RadioButtonSolid/RadioButtonSolid.js';
import '../../atoms/Icons/ArrowDownCircleOutline/ArrowDownCircleOutline.js';
import '../../atoms/Icons/MinusCircleOutline/MinusCircleOutline.js';
import '../../atoms/Icons/PlusCircleOutline/PlusCircleOutline.js';
import '../../atoms/Icons/ArrowUpCircleOutline/ArrowUpCircleOutline.js';
import '../../atoms/Icons/InfoSolidCircleOutline/InfoSolidCircleOutline.js';
import '../../atoms/Icons/WarningSolidCircleOutline/WarningSolidCircleOutline.js';
import '../../atoms/Icons/InfoCircleOutline/InfoCircleOutline.js';
import '../../atoms/Icons/WarningCircleOutline/WarningCircleOutline.js';
import '../../atoms/Icons/CrossCircleOutline/CrossCircleOutline.js';
import '../../atoms/Icons/TickCircleOutline/TickCircleOutline.js';
import '../../atoms/Icons/Socials/Facebook/Facebook.js';
import '../../atoms/Icons/Socials/Instagram/Instagram.js';
import '../../atoms/Icons/Socials/Tiktok/Tiktok.js';
import '../../atoms/Icons/Socials/LinkedIn/LinkedIn.js';
import '../../atoms/Icons/Socials/FacebookWithoutCircle/FacebookWithoutCircle.js';
import '../../atoms/Icons/Payments/Visa/Visa.js';
import '../../atoms/Icons/Payments/Mastercard/Mastercard.js';
import '../../atoms/Icons/Payments/Amex/Amex.js';
import '../../atoms/Icons/Payments/ApplePay/ApplePay.js';
import '../../atoms/Icons/Payments/GooglePay/GooglePay.js';
import '../../atoms/Icons/Payments/Stripe/Stripe.js';
import '../../atoms/Icons/Payments/PoweredByStripe/PoweredByStripe.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoWhite/ApplePayLogoWhite.js';
import '../../atoms/Icons/WalletPayment/ApplePayLogoBlack/ApplePayLogoBlack.js';
import '../../atoms/Icons/WalletPayment/GooglePayLogo/GooglePayLogo.js';
import '../../atoms/Icons/Partners/Ups/Ups.js';
import '../../atoms/Icons/Partners/Trustpilot/Trustpilot.js';
import '../../atoms/Icons/Dot/Dot.js';
import '../../atoms/Flags/Flag.js';
import 'react';
import '../../atoms/Typography/Typography.styles.js';
import '../../atoms/Typography/TypographyStyles.js';
import '../../atoms/Button/ButtonStyles.js';
import '../../atoms/WalletPaymentButton/WalletPaymentButton.styles.js';
import '../../atoms/Link/Link.styles.js';
import '../../atoms/Switch/Switch.styles.js';
import '../../atoms/GlobalNotification/GlobalNotification.styles.js';
import Button from '../../atoms/Button/Button.js';
import '../../atoms/PremiumLabel/PremiumLabel.styles.js';
import '../../atoms/Tooltip/Tooltip.styles.js';
import '../../atoms/Toast/Toast.styles.js';
import '../../atoms/SiteSettingsButton/SiteSettingsButton.styles.js';
import '../../atoms/Hint/Hint.styles.js';
import '../../atoms/Pictograms/Auth/Auth.js';
import '../../atoms/Pictograms/BoxNew/BoxNew.js';
import '../../atoms/Pictograms/Delivery/Delivery.js';
import '../../atoms/Pictograms/Return/Return.js';
import '../Carousel/Carousel.styles.js';
import 'react-hook-form';
import '../Form/Form.styles.js';
import '../Form/TextInput/TextInput.styles.js';
import '../Form/CheckboxInput/CheckboxInput.styles.js';
import '../Form/RadioInput/RadioInput.js';
import '../Form/SelectInput/SelectInput.styles.js';
import '../Footer/Footer.styles.js';
import '../Footer/BottomContent/BottomContent.styles.js';
import '../../molecules/Accordion/Root/Root.styles.js';
import '../../molecules/Accordion/Item/Item.js';
import '../Footer/SiteNavigationLinks/SiteNavigationLinks.styles.js';
import '../Footer/SiteNavigationGroups/SiteNavigationGroups.styles.js';
import '../../molecules/Dialog/Dialog.styles.js';
import '../CookieBanner/SimpleCookieForm/SimpleCookieForm.styles.js';
import '../CookieBanner/ExpandedCookieForm/ExpandedCookieForm.styles.js';
import '../CookieBanner/ExpandedCookieForm/PreferenceItem/PreferenceItem.styles.js';
import './AddressForm.schema.js';
import '../../atoms/LocationReminder/LocationReminder.styles.js';
import '../../atoms/LocationReminder/LocationReminder.schema.js';

var _a, _b, _c;
var variables = {
    phoneInputColorFocus: "#03b2cb",
    phoneInputInternationalIconPhoneOpacity: 0.8,
    phoneInputInternationalIconGlobeOpacity: 0.65,
    phoneInputCountrySelectMarginRight: "0.35em",
    phoneInputCountrySelectArrowWidth: "0.3em",
    phoneInputCountrySelectArrowMarginLeft: "0.35em",
    phoneInputCountrySelectArrowBorderWidth: "1px",
    phoneInputCountrySelectArrowOpacity: 0.45,
    phoneInputCountrySelectArrowColor: "currentColor",
    phoneInputCountrySelectArrowColorFocus: "#03b2cb",
    phoneInputCountrySelectArrowTransform: "rotate(45deg)",
    phoneInputCountryFlagAspectRatio: 1.5,
    phoneInputCountryFlagHeight: "1em",
    phoneInputCountryFlagBorderWidth: "1px",
    phoneInputCountryFlagBorderColor: "rgba(0,0,0,0.5)",
    phoneInputCountryFlagBorderColorFocus: "#03b2cb",
    phoneInputCountryFlagBackgroundColorLoading: "rgba(0,0,0,0.1)",
};
var AddressFormWrap = styled("main")({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacing[5],
    },
});
var AddressTwoCol = styled.section((_a = {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: tokens.spacing[4],
        justifyContent: "space-between",
        div: {
            flex: 1,
        }
    },
    _a[mediaQuery.m.max] = {
        flexDirection: "column",
    },
    _a));
var AddressSearchWrap = styled.div({
    display: "flex",
    flexDirection: "column",
    gap: tokens.spacing[4],
    position: "relative",
    zIndex: tokens.zIndex.above,
    "div > input:not(:placeholder-shown)": {
        borderRadius: "".concat(tokens.borderRadius.m, " ").concat(tokens.borderRadius.m, " 0 0"),
    },
});
var AddressSearchResults = styled(Content2)(function (_a) {
    var isOpen = _a.isOpen;
    return ({
        display: isOpen ? "flex" : "none",
        flexDirection: "column",
        borderRadius: "0 0 ".concat(tokens.borderRadius.m, " ").concat(tokens.borderRadius.m),
        width: "var(--radix-popper-anchor-width)",
        height: "auto",
        maxHeight: "20rem",
        overflow: "auto",
        backgroundColor: tokens.color.yeezy[0],
        border: generateBorder("xs", "solid", "airJordan.500"),
        marginTop: "-1px",
        boxShadow: "hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px",
    });
});
var AddressSearchResult = styled.button({
    all: "unset",
    padding: generatePadding("spacing.3", "spacing.4"),
    borderBottom: generateBorder("xs", "solid", "airJordan.200"),
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    span: {
        color: tokens.color.airJordan[500],
    },
    "&:hover, &:focus-visible": {
        background: tokens.color.airJordan[50],
    },
    "&:last-of-type": {
        borderBottom: "none",
    },
});
var StyledPhoneInput = styled.div(function (_a) {
    var hasError = _a.hasError;
    return ({
        position: "relative",
        "input, select": {
            width: "100%",
            border: "".concat(tokens.borderWidth.xs, " solid ").concat(hasError ? tokens.color.roshe[600] : tokens.color.airJordan[400]),
            backgroundColor: tokens.color.yeezy[0],
            borderRadius: tokens.borderRadius.m,
            fontFamily: tokens.fontFamilies.primary,
            fontSize: tokens.fontSize[3],
            height: "56px",
            color: tokens.color.airJordan.p,
            zIndex: tokens.zIndex.base,
            "&:focus": {
                outline: "none",
                borderColor: hasError
                    ? tokens.color.roshe[600]
                    : tokens.color.airJordan[600],
            },
            input: {
                zIndex: tokens.zIndex.above,
                position: "relative",
            },
        },
        ".PhoneInput": {
            display: "flex",
            alignItems: "center",
        },
        ".PhoneInputInput": {
            flex: 1,
            minWidth: 0,
            maxWidth: "calc(100% - 50px)",
            marginLeft: "auto",
            position: "relative",
            zIndex: tokens.zIndex.above,
        },
        ".PhoneInputCountryIcon": {
            width: "calc(".concat(variables.phoneInputCountryFlagHeight, " * ").concat(variables.phoneInputCountryFlagAspectRatio, ")"),
            height: variables.phoneInputCountryFlagHeight,
            margin: "0 5px",
        },
        ".PhoneInputCountryIcon--square": {
            width: variables.phoneInputCountryFlagHeight,
        },
        ".PhoneInputCountryIcon--border": {
            backgroundColor: variables.phoneInputCountryFlagBackgroundColorLoading,
            boxShadow: "0 0 0 ".concat(variables.phoneInputCountryFlagBorderWidth, " ").concat(variables.phoneInputCountryFlagBorderColor, ",\n      inset 0 0 0 ").concat(variables.phoneInputCountryFlagBorderWidth, " ").concat(variables.phoneInputCountryFlagBorderColor),
        },
        ".PhoneInputCountryIconImg": {
            display: "block",
            width: "100%",
            height: "100%",
        },
        ".PhoneInputInternationalIconPhone": {
            opacity: variables.phoneInputInternationalIconPhoneOpacity,
        },
        ".PhoneInputInternationalIconGlobe": {
            opacity: variables.phoneInputInternationalIconGlobeOpacity,
        },
        ".PhoneInputCountry": {
            position: "absolute",
            alignSelf: "stretch",
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginRight: variables.phoneInputCountrySelectMarginRight,
            height: "56px",
        },
        ".PhoneInputCountrySelect": {
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
            zIndex: 1,
            border: 0,
            opacity: 0,
            cursor: "pointer",
            "&:disabled, &:readonly": {
                cursor: "default",
            },
        },
        ".PhoneInputCountrySelectArrow": {
            display: "block",
            content: "''",
            width: variables.phoneInputCountrySelectArrowWidth,
            height: variables.phoneInputCountrySelectArrowWidth,
            marginLeft: variables.phoneInputCountrySelectArrowMarginLeft,
            borderStyle: "solid",
            borderColor: variables.phoneInputCountrySelectArrowColor,
            borderTopWidth: 0,
            borderBottomWidth: variables.phoneInputCountrySelectArrowBorderWidth,
            borderLeftWidth: 0,
            borderRightWidth: variables.phoneInputCountrySelectArrowBorderWidth,
            transform: variables.phoneInputCountrySelectArrowTransform,
            opacity: variables.phoneInputCountrySelectArrowOpacity,
        },
        ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon + .PhoneInputCountrySelectArrow": {
            opacity: 1,
            color: variables.phoneInputCountrySelectArrowColorFocus,
        },
        ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon--border": {
            boxShadow: "0 0 0 ".concat(variables.phoneInputCountryFlagBorderWidth, " ").concat(variables.phoneInputCountryFlagBorderColorFocus, ",\n      inset 0 0 0 ").concat(variables.phoneInputCountryFlagBorderWidth, " ").concat(variables.phoneInputCountryFlagBorderColorFocus),
        },
        ".PhoneInputCountrySelect:focus + .PhoneInputCountryIcon .PhoneInputInternationalIconGlobe": {
            opacity: 1,
            color: variables.phoneInputCountrySelectArrowColorFocus,
        },
    });
});
var AddressFormSection = styled.section((_b = {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacing[4],
        background: tokens.color.yeezy[0],
        padding: tokens.spacing[7],
        h4: {
            marginBottom: tokens.spacing[2],
        }
    },
    _b[mediaQuery.m.max] = {
        padding: generatePadding(tokens.spacing[7], tokens.spacing[6]),
    },
    _b));
var AddressFormFooter = styled.footer((_c = {
        display: "flex",
        flexDirection: "column",
        gap: tokens.spacing[5],
        padding: generatePadding(tokens.spacing[5], 0)
    },
    _c[mediaQuery.m.max] = {
        padding: generatePadding(tokens.spacing[3], tokens.spacing[5], tokens.spacing[5]),
    },
    _c));
var SubmitButton = styled(Button)({
    marginLeft: "auto",
});

export { AddressFormFooter, AddressFormSection, AddressFormWrap, AddressSearchResult, AddressSearchResults, AddressSearchWrap, AddressTwoCol, StyledPhoneInput, SubmitButton };
//# sourceMappingURL=AddressForm.styles.js.map
